module.exports = __webpack_public_path__ + "img/instagram.58ccd524.svg";